import _colorsDict from "../../dict/colors.js";
import _getShortestLine from "../utility/getShortestLine.js";
import _getLongestLine from "../utility/getLongestLine.js";
import _findCenter from "../utility/findCenter.js";
import _eol from "eol";
import _stripTags from "../quill/stripTags.js";
import _extractStyleAttributes from "../quill/extractStyleAttributes.js";
import _convertToPlainText from "../quill/convertToPlainText.js";
import _convertToPlainTextCustom from "../quill/convertToPlainTextCustom.js";
import _quillClasses from "../../dict/quillClasses.js";
import _convertToHtml from "../quill/convertToHtml.js";
import _Event from "../../classes/event.js";
import _vchipLookup from "../../dict/vChipRatings.js";
import _sccLookup from "../../dict/608.js";
const sccLookup = _sccLookup;
const vchipLookup = _vchipLookup;
const Event = _Event;
const convertToHtml = _convertToHtml;
const quillClasses = _quillClasses;
const convertToPlainTextCustom = _convertToPlainTextCustom;
const convertToPlainText = _convertToPlainText;
const extractStyleAttributes = _extractStyleAttributes;
const stripTags = _stripTags;
const eol = _eol;
const findCenter = _findCenter;
const getLongestLine = _getLongestLine;
const getShortestLine = _getShortestLine;
const colorsDict = _colorsDict;
const {
  BRIGHT_GREEN_HEX,
  toBroadcastColor
} = colorsDict;
export default {
  colorMapping: {
    "WHITE": "#FFFFFF",
    "GREEN": BRIGHT_GREEN_HEX,
    "BLUE": "#0000FF",
    "CYAN": "#00FFFF",
    "RED": "#FF0000",
    "YELLOW": "#FFFF00",
    "MAGENTA": "#FF00FF",
    "BLACK": "#000000",
    "NONE": ""
  },
  Display: class {
    constructor(options = {
      style: "Pop-On",
      start: false,
      end: false,
      lines: []
    }) {
      this.style = options.style || "Pop-On", this.start = options.start || false, this.end = options.end || false, this.lines = options.lines || [];
    }
    insertLine(options = {
      text: "",
      xPos: 1,
      yPos: 1,
      italics: false,
      underline: false,
      bold: false,
      color: "#FFFFFF",
      background: "#000000",
      opacity: 1
    }) {
      this.lines.push({
        text: options.text || "",
        xPos: options.xPos,
        //0-31
        yPos: options.yPos,
        //0-14 
        italics: options.italics,
        underline: options.underline,
        bold: options.bold,
        color: options.color || "#FFFFFF",
        background: options.background || "#000000",
        opacity: options.opacity || 1
      });
    }
  },
  decodeDisplay: function (display, win) {
    let ccEvent = new Event({
      style: display.style,
      start: display.start,
      end: display.end
    });

    // console.log("-------");
    // console.log(display);
    let position = this.getPositionFromDisplay(JSON.parse(JSON.stringify(display.lines)), win, display.style);
    ccEvent.text = convertToHtml(this.getTextFromDisplay(display.lines), [quillClasses.align[position.alignment]]);

    // console.log(ccEvent.text);
    if (!ccEvent.text) {
      return false;
    }
    ccEvent.alignment = position.alignment;
    ccEvent.xPos = position.xPos;
    ccEvent.yPos = position.yPos;
    return ccEvent;
  },
  getTextFromDisplay: function (lines) {
    if (lines.length === 0) {
      return false;
    }
    let text = "",
      yPos,
      xPos;
    lines.filter(line => {
      return line.text.trim();
    }).sort((lineA, lineB) => {
      return lineA.yPos - lineB.yPos || lineA.xPos - lineB.xPos;
    }).forEach((line, index, lines) => {
      if (lines[index + 1] && line.yPos === lines[index + 1].yPos && line.xPos === lines[index + 1].xPos && lines[index + 1].text.trim().length >= line.text.trim().length) {
        // console.log("Duplicate Line:", lines);
        return;
      } else if (line.yPos === yPos) {
        text += " " + line.text;
      } else {
        text += "\n" + line.text;
      }
      if (line.text.match(/<em>/) && (line.text.match(/<em>/g) || []).length !== (line.text.match(/<\/em>/g) || []).length) {
        text += "</em>";
      }
      if (line.text.match(/<u>/) && (line.text.match(/<u>/g) || []).length !== (line.text.match(/<\/u>/g) || []).length) {
        text += "</u>";
      }
      yPos = line.yPos;
      xPos = line.xPos;
    });

    // console.log("---------------");
    // console.log(text);
    /* Extended characters already overwrote their fallback character during decode, so there is nothing left to strip here. */
    return text.trim();
  },
  getPositionFromDisplay: function (lines, win, style) {
    // console.log("-------");
    // console.log(lines);
    // console.log("-------");
    // Scenerist default dimensions
    const SCENERIST_WIDTH = 32;
    const SCENERIST_HEIGHT = 15;

    // Get display dimensions with defaults
    const displayWidth = Number.isFinite(win?.width) ? win.width : SCENERIST_WIDTH;
    const displayHeight = Number.isFinite(win?.height) ? win.height : SCENERIST_HEIGHT;
    let position = {
      xPos: "center",
      yPos: "end",
      alignment: "center"
    };
    if (!Array.isArray(lines) || lines.length === 0) {
      return position;
    }
    let normalizedLines = lines.filter(line => line && typeof line.text === "string" && line.text.trim().length > 0).map(line => ({
      ...line
    })).sort((lineA, lineB) => lineA.yPos - lineB.yPos || lineA.xPos - lineB.xPos);
    if (normalizedLines.length === 0) {
      return position;
    }
    normalizedLines = this.organizeLines(normalizedLines);
    let self = this;
    normalizedLines = normalizedLines.filter(line => line && typeof line.text === "string" && line.text.trim().length > 0).map(line => {
      let text = line.text;
      text = self.replaceMusicNotes(text);
      return {
        ...line,
        text: text.trim()
      };
    }).sort((lineA, lineB) => lineA.yPos - lineB.yPos || lineA.xPos - lineB.xPos);
    if (normalizedLines.length === 0) {
      return position;
    }
    const totalLines = normalizedLines.length;
    const firstLine = normalizedLines[0];
    const getLineEnd = line => line.xPos + (line.text ? line.text.length : 0);
    const longestLineDetails = normalizedLines.reduce((acc, line) => {
      const length = line.text ? line.text.length : 0;
      if (!acc || length > acc.length || length === acc.length && line.yPos < acc.line.yPos) {
        return {
          line,
          length
        };
      }
      return acc;
    }, null);
    const shortestLineDetails = normalizedLines.reduce((acc, line) => {
      const length = line.text ? line.text.length : 0;
      if (!acc || length < acc.length || length === acc.length && line.yPos < acc.line.yPos) {
        return {
          line,
          length
        };
      }
      return acc;
    }, null);

    // console.log("Longest Line Details:", longestLineDetails);
    // console.log("Shortest Line Details:", shortestLineDetails);

    // Calculate difference between longest line and shortest line
    let lineLengthDelta = longestLineDetails.length - shortestLineDetails.length;
    if (totalLines === 1 && (style === "Pop-On" || style === "Paint-On")) {
      position.alignment = "center";
    } else if (totalLines === 1 && !firstLine.xPos) {
      position.alignment = "left";
    } else if (totalLines === 1) {
      position.alignment = "center";
    } else {
      const sameStart = normalizedLines.every(line => line.xPos === normalizedLines[0].xPos);
      const sameEnd = normalizedLines.every(line => getLineEnd(line) === getLineEnd(normalizedLines[0]));
      if (sameStart && sameEnd) {
        position.alignment = "center";
      } else if (sameStart && (lineLengthDelta > 1 || longestLineDetails.line.xPos === 0)) {
        position.alignment = "left";
      } else if (sameEnd) {
        position.alignment = "right";
      } else if (totalLines > 1) {
        //We need to compare the longest line and the shortest line to see if the shortest line is centered within the longest line. If it is, then we can assume the alignment is center. If not, then we can assume the alignment is left or right based on the position of the longest line.
        const longestCenter = longestLineDetails.line.xPos + Math.floor(longestLineDetails.length / 2);
        const shortestCenter = shortestLineDetails.line.xPos + Math.floor(shortestLineDetails.length / 2);

        // console.log("Longest Line Center:", longestCenter);
        // console.log("Shortest Line Center:", shortestCenter);
        if (Math.abs(longestCenter - shortestCenter) <= 2) {
          position.alignment = "center";
        } else if (shortestLineDetails.line.xPos <= longestLineDetails.line.xPos) {
          position.alignment = "left";
        } else if (shortestLineDetails.line.xPos > longestLineDetails.line.xPos) {
          position.alignment = "right";
        } else {
          position.alignment = "center";
        }
      } else {
        position.alignment = "center";
      }
    }
    const longestLine = longestLineDetails ? longestLineDetails.line : firstLine;
    const longestLength = longestLineDetails ? longestLineDetails.length : longestLine.text ? longestLine.text.length : 0;
    const centerStart = parseInt((SCENERIST_WIDTH - longestLength) / 2);

    // console.log("Longest Line:", longestLine);
    if (longestLength === 0) {
      position.xPos = "center";
    } else if (longestLine.xPos <= 0) {
      position.xPos = "start";
    } else if (longestLine.xPos + longestLength >= SCENERIST_WIDTH) {
      position.xPos = "end";
    } else if (Number.isFinite(centerStart) && Math.abs(longestLine.xPos - centerStart) <= 2) {
      position.xPos = "center";
    } else {
      const availableWidth = Math.max(displayWidth - longestLength, 0);
      const normalizedSpan = Math.max(SCENERIST_WIDTH - longestLength, 1);
      let normalizedStart = longestLine.xPos / normalizedSpan;
      normalizedStart = Math.min(1, Math.max(0, normalizedStart));
      let offset = Math.round(normalizedStart * availableWidth);
      if (offset + longestLength > displayWidth) {
        offset = Math.max(0, displayWidth - longestLength);
      }
      position.xPos = offset;
    }
    const highestY = normalizedLines.reduce((max, line) => Math.max(max, line.yPos), firstLine.yPos);
    const blockRows = Math.max(totalLines, highestY - firstLine.yPos);
    if (firstLine.yPos <= 0) {
      position.yPos = "start";
    } else if (firstLine.yPos + blockRows >= SCENERIST_HEIGHT) {
      position.yPos = "end";
    } else {
      position.yPos = parseInt(firstLine.yPos) + 1;
    }

    // console.log("Calculated Position:", position);
    return position;
  },
  organizeLines: function (lines) {
    let sameLineTest = true,
      yPos;
    while (sameLineTest) {
      sameLineTest = false;
      yPos = undefined;
      lines.forEach((line, index, lines) => {
        lines[index].text = stripTags(lines[index].text);
        //strip color tags as well (<WHITE>, <RED>, <CYAN>, <BLACK>, <GREEN>, <BLUE>, <MAGENTA>, and <YELLOW>)
        lines[index].text = lines[index].text.replace(/<\/?(WHITE|RED|CYAN|BLACK|GREEN|BLUE|MAGENTA|YELLOW)\b[^>]*>/gi, '');
        // console.log(lines[index].text);
        if (line.yPos === yPos) {
          lines[index - 1].text += " " + line.text.trim();
          lines[index].text = "";
          sameLineTest = true;
        } else {
          yPos = line.yPos;
        }
      });
      lines = lines.filter(line => {
        return line.text;
      });
    }
    return lines;
  },
  getHorzDetails: function (lines) {
    //console.log(lines);
    let self = this;
    return lines.map(line => {
      let alignment;
      line.text = self.replaceSpecialChars(line.text);
      line.text = self.replaceMusicNotes(line.text);

      // console.log(line.text);
      let text = line.text;
      let center = findCenter(32, text.length);
      if (line.xPos >= center - 2.5 && line.xPos <= center + 2.5) {
        alignment = "center";
      } else if (line.xPos > center) {
        alignment = "right";
      } else {
        alignment = "left";
      }
      return {
        text: line.text,
        xPos: line.xPos,
        length: text.length,
        alignment: alignment,
        end: line.xPos + text.length
      };
    });
  },
  getAlignmentFromDetails: function (details) {
    // console.log(details);
    if (details.length === 1) {
      return details[0].alignment;
    }
    let xPosSame = details.every(detail => {
      return detail.xPos === details[0].xPos;
    });
    let endSame = details.every(detail => {
      return detail.end === details[0].end;
    });
    let alignmentCenter = details.every(detail => {
      return detail.alignment === "center";
    });
    let anyLeft = details.some(detail => {
      return detail.alignment === "left";
    });
    let anyRight = details.some(detail => {
      return detail.alignment === "right";
    });
    if (alignmentCenter) {
      return "center";
    } else if (xPosSame) {
      return "left";
    } else if (endSame) {
      return "right";
    } else if (anyLeft) {
      return "left";
    } else if (anyRight) {
      return "right";
    } else {
      return "center";
    }
  },
  escapeExtChars: function (eventDetails) {
    if (eventDetails.lines && eventDetails.lines.length > 0) {
      eventDetails.lines.forEach((line, index, lines) => {
        sccLookup.specialCharsFilter.forEach(specialChar => {
          let regexPattern = new RegExp(`\\` + specialChar, "g");
          lines[index] = lines[index].replace(regexPattern, sccLookup.specialCharacterReplacement[specialChar] + specialChar);
        });
        lines[index] = this.duplicateMusicNotes(lines[index]);
      });
    }
    return eventDetails;
  },
  getEventDetails: function (event) {
    /* Zero-width and invisible characters have no 608 mapping, so they would encode as
       an "80" pad byte and skew line-length math used for positioning. */
    const invisibleChars = /[\u200B\u200C\u200D\u2060\uFEFF]/g;
    let eventTextPlainFormat = convertToPlainTextCustom(event.text, "\n", false, "strong", "em", "u", true).replace(invisibleChars, "");
    let eventTextPlain = convertToPlainText(event.text).replace(invisibleChars, "");
    let longestLine = getLongestLine(eventTextPlain);
    let shortestLine = getShortestLine(eventTextPlain);
    let details = {
      text: eventTextPlainFormat,
      lines: eol.split(eventTextPlainFormat),
      plainText: eventTextPlain,
      longestLine: longestLine,
      shortestLine: shortestLine,
      alignment: event.alignment,
      xPos: event.xPos,
      yPos: event.yPos,
      xOffset: event.xOffset,
      yOffset: event.yOffset,
      style: event.style,
      start: event.start,
      end: event.end
    };
    // console.log(details);
    return details;
    /* NOTES:
        xOffset : parseInt((event.xOffset/win.width)*100),
        yOffset : parseInt((event.yOffset/win.height)*100) 
    */
  },
  getCodeByCmd: function (codes, cmd) {
    if (cmd && cmd.charCodeAt(0) === 160) {
      cmd = " ";
    }
    let sccCode = Object.keys(codes).find(code => codes[code] === cmd);
    if (!sccCode) {
      if (cmd.charCodeAt(0) === 8217) {
        return "a7";
      }
    }
    return sccCode || "80";
  },
  replaceSpecialChars: function (text) {
    return text.replace(/À/g, "AÀ").replace(/Â/g, "AÂ").replace(/Ç/g, "CÇ").replace(/É/g, "EÉ").replace(/È/g, "EÈ").replace(/Ê/g, "EÊ").replace(/Ë/g, "EË").replace(/ë/g, "eë").replace(/Î/g, "IÎ").replace(/Ï/g, "IÏ").replace(/ï/g, "iï").replace(/Ô/g, "OÔ").replace(/Ù/g, "UÙ").replace(/ù/g, "uù").replace(/Û/g, "UÛ").replace(/Ú/g, "UÚ").replace(/Ã/g, "AÃ").replace(/ã/g, "aã").replace(/Í/g, "IÍ").replace(/Ì/g, "IÌ").replace(/ì/g, "iì").replace(/Ò/g, "oÒ").replace(/ò/g, "oò").replace(/Õ/g, "OÕ").replace(/õ/g, "oõ").replace(/Ä/g, "AÄ").replace(/¿/g, "?¿").replace(/¡/g, "!¡").replace(/ä/g, "aä").replace(/ü/g, "uü").replace(/Ü/g, "UÜ").replace(/Ö/g, "OÖ").replace(/ö/g, "oö").replace(/Å/g, "AÅ").replace(/å/g, "aå").replace(/‘/g, "'‘").replace(/♪/g, "♪♪").replace(/♪♪♪♪/g, "♪♪♪");
  },
  getSccPosition: function (textLine, details, lineIndex, win, horzOffset = 0) {
    let position = {
      posCode: false,
      tabCode: false
    };
    let xPos = Math.max(0, this.getXPos(textLine, details, win));
    let yPos = this.getYPos(stripTags(textLine), details, lineIndex, win);

    // console.log("----");
    // console.log(stripTags(textLine), textLine.length, xPos, horzOffset);

    if (stripTags(textLine).length + xPos + horzOffset > 32) {
      xPos -= horzOffset;
    }
    let tabs = xPos % 4;
    let column = xPos - tabs; // 0,4,8,12,16,20,24,28
    column = column.toString().padStart(2, '0');
    position.tabCode = "{TAB0" + tabs + "}";
    position.posCode = "{" + yPos.toString().padStart(2, '0') + "_" + column.toString().padStart(2, '0') + "}";
    //console.log(position);
    return position;
  },
  getXPos: function (textLine, details, win) {
    /**
     * Translates horizontal positioning from Closed Caption Creator to SCC character offset (0-31).
     * 
     * @param {string} textLine - The text line being positioned (may contain HTML tags)
     * @param {Object} details - Event details including alignment, xPos, yPos, longestLine, etc.
     * @param {Object} win - Window object with width, height, xPadding, yPadding properties
     * @returns {number} Character offset (0-31) for SCC positioning
     */

    const SCC_DISPLAY_WIDTH = 32;
    let xPos = 0;

    // console.log("-----");
    // console.log(textLine);
    textLine = stripTags(textLine);
    textLine = this.replaceSpecialChars(textLine);
    textLine = this.replaceMusicNotes(textLine);

    // console.log(details);
    // console.log(textLine);

    const longestLineLength = details.longestLine ? details.longestLine.length : 0;
    const textLineLength = textLine.length;

    // Handle the four xPos scenarios: "start", "center", "end", or integer

    if (details.xPos === "start") {
      // Scenario 1: xPos === "start"
      if (details.alignment === "left") {
        xPos = 0;
      } else if (details.alignment === "center") {
        // Center within the longest line block
        xPos = Math.floor((longestLineLength - textLineLength) / 2);
      } else if (details.alignment === "right") {
        // Right align within the longest line block
        xPos = longestLineLength - textLineLength;
      }
    } else if (details.xPos === "center") {
      // Scenario 2: xPos === "center"
      if (details.alignment === "left") {
        // Left align, but center the block on screen
        xPos = Math.floor((SCC_DISPLAY_WIDTH - longestLineLength) / 2);
      } else if (details.alignment === "center") {
        // Center the line on screen
        xPos = Math.round((SCC_DISPLAY_WIDTH - textLineLength) / 2);
        // console.log("Centering line on screen. Line length:", textLineLength, "Calculated xPos:", xPos);
      } else if (details.alignment === "right") {
        // Right align within centered block
        xPos = Math.floor((SCC_DISPLAY_WIDTH - longestLineLength) / 2) + (longestLineLength - textLineLength);
      }
    } else if (details.xPos === "end") {
      // Scenario 3: xPos === "end"
      if (details.alignment === "left") {
        // Left align at end of screen
        xPos = SCC_DISPLAY_WIDTH - longestLineLength;
      } else if (details.alignment === "center") {
        // Center within block at end of screen
        xPos = SCC_DISPLAY_WIDTH - longestLineLength + Math.floor((longestLineLength - textLineLength) / 2);
      } else if (details.alignment === "right") {
        // Right align at end of screen
        xPos = SCC_DISPLAY_WIDTH - textLineLength;
      }
    } else if (typeof details.xPos === "number") {
      // Scenario 4: xPos is an integer (character offset)
      const offset = details.xPos;
      if (details.alignment === "left") {
        xPos = offset;
      } else if (details.alignment === "center") {
        // Center within the longest line block, then add offset
        xPos = Math.floor((longestLineLength - textLineLength) / 2) + offset;
      } else if (details.alignment === "right") {
        // Right align within the longest line block, then add offset
        xPos = longestLineLength - textLineLength + offset;
      }
    }

    // Safety check: make sure line doesn't go off screen to the right
    if (xPos + textLineLength > SCC_DISPLAY_WIDTH) {
      xPos = SCC_DISPLAY_WIDTH - textLineLength;
    }

    // Safety check: make sure line doesn't start before screen
    // console.log("XPOS:", xPos);
    xPos = Math.max(0, xPos);
    return Math.floor(xPos);
  },
  getYPos: function (textLine, details, lineIndex, win) {
    /**
     * Translates vertical positioning from Closed Caption Creator to SCC line offset (0-14).
     * 
     * @param {string} textLine - The text line being positioned (unused but kept for consistency)
     * @param {Object} details - Event details including yPos, lines array
     * @param {number} lineIndex - The index of the current line within the event
     * @param {Object} win - Window object with height property
     * @returns {number} Line offset (0-14) for SCC positioning
     */

    const SCC_DISPLAY_HEIGHT = 15; // Lines 0-14 (15 total lines)
    const MAX_LINE_OFFSET = 14;
    let yPos = 0;
    const totalLines = details.lines ? details.lines.length : 1;

    // Handle the four yPos scenarios: "start", "center", "end", or integer

    if (details.yPos === "start") {
      // Scenario 1: yPos === "start" - lines start at top
      yPos = lineIndex;
    } else if (details.yPos === "center") {
      // Scenario 2: yPos === "center" - center the block vertically
      yPos = Math.floor((SCC_DISPLAY_HEIGHT - totalLines) / 2) + lineIndex;
    } else if (details.yPos === "end") {
      // Scenario 3: yPos === "end" - lines align to bottom
      yPos = SCC_DISPLAY_HEIGHT - totalLines + lineIndex;
    } else if (typeof details.yPos === "number") {
      // Scenario 4: yPos is an integer (line offset from top)
      yPos = details.yPos + lineIndex - 1;
    }

    // Safety checks to ensure lines stay within bounds

    // Ensure the entire block fits on screen from this line onwards
    const linesRemaining = totalLines - lineIndex;
    const maxAllowedYPos = MAX_LINE_OFFSET - (linesRemaining - 1);
    if (yPos > maxAllowedYPos) {
      yPos = maxAllowedYPos;
    }

    // Ensure yPos doesn't exceed maximum line offset
    if (yPos > MAX_LINE_OFFSET) {
      yPos = MAX_LINE_OFFSET;
    }

    // Ensure yPos is not negative
    yPos = Math.max(0, yPos);
    return Math.floor(yPos);
  },
  getPositionCodes: function (textLine, details, lineIndex, channel, win, horzOffset = 0) {
    //console.log(details, lineIndex);
    let positionCodes = [];
    if (details.style === "Roll-Up 2") {
      positionCodes.push(this.getCodeByCmd(sccLookup[channel], "{ROLLUP2}"));
      positionCodes.push(this.getCodeByCmd(sccLookup[channel], "{NEW LINE}"));
      let position = this.getSccPosition(textLine, details, lineIndex, win);
      positionCodes.push(this.getCodeByCmd(sccLookup[channel], position.posCode));
    } else if (details.style === "Roll-Up 3") {
      positionCodes.push(this.getCodeByCmd(sccLookup[channel], "{ROLLUP3}"));
      positionCodes.push(this.getCodeByCmd(sccLookup[channel], "{NEW LINE}"));
      let position = this.getSccPosition(textLine, details, lineIndex, win);
      positionCodes.push(this.getCodeByCmd(sccLookup[channel], position.posCode));
    } else if (details.style === "Roll-Up 4") {
      positionCodes.push(this.getCodeByCmd(sccLookup[channel], "{ROLLUP4}"));
      positionCodes.push(this.getCodeByCmd(sccLookup[channel], "{NEW LINE}"));
      let position = this.getSccPosition(textLine, details, lineIndex, win);
      positionCodes.push(this.getCodeByCmd(sccLookup[channel], position.posCode));
    } else if (details.style === "Paint-On") {
      if (lineIndex === 0) {
        positionCodes.push(this.getCodeByCmd(sccLookup[channel], "{CLEAR DISPLAY}"));
        positionCodes.push(this.getCodeByCmd(sccLookup[channel], "{PAINT ON}"));
      }
      let position = this.getSccPosition(textLine, details, lineIndex, win, horzOffset);
      positionCodes.push(this.getCodeByCmd(sccLookup[channel], position.posCode));
      if (position.tabCode !== "{TAB00}") {
        positionCodes.push(this.getCodeByCmd(sccLookup[channel], position.tabCode));
      }
    } else {
      /* Pop-On */
      //console.log(details);
      if (lineIndex === 0) {
        positionCodes.push(this.getCodeByCmd(sccLookup[channel], "{RESUME LOADING}"));
      }
      let position = this.getSccPosition(textLine, details, lineIndex, win, horzOffset);
      // console.log(position,details);
      positionCodes.push(this.getCodeByCmd(sccLookup[channel], position.posCode));
      if (position.tabCode !== "{TAB00}") {
        positionCodes.push(this.getCodeByCmd(sccLookup[channel], position.tabCode));
      }
    }
    //console.log(positionCodes);
    return positionCodes.filter(code => {
      return code && code !== "80";
    });
  },
  encodeEvent: function (details, channel = "ch01", win) {
    let cmds = [];
    if (!details.plainText) {
      /* Empty Pop-On events load setup codes only. On-screen clear is handled
         by getDisplayOrClearCommands at the prior endFrame / this startFrame;
         embedding an EDM here would wipe the displayed caption during preload. */
      if (details.style === "Pop-On" || !details.style) {
        cmds.push(this.getCodeByCmd(sccLookup[channel], "{RESUME LOADING}"));
        cmds.push(this.getCodeByCmd(sccLookup[channel], "{14_16}"));
      }
      return cmds.filter(code => code && code !== "80");
    }
    // console.log("-----");
    // console.log(details);
    details.lines.forEach((line, index) => {
      let horzOffset = 0;
      let posCmds = [];
      let textCmds = [];
      //line = this.replaceSpecialChars(line);
      // console.log(line);
      //remove Duplicate spaces
      line = line.replace(/\t/g, ' ').replace(/ +/g, ' ').replace(/\s+(<\/[^>]+>)/g, '$1').replace(/(<[^>\/]+>)\s+/g, '$1').replace(/<([^>]+)>\s+<\/\1>/g, '<$1></$1>').replace(/<\/em> /g, "</em>");
      // console.log(line);

      let chars = line.split("");
      while (chars.length > 0) {
        let char = chars.shift();
        if (char === "<") {
          horzOffset = horzOffset + 0.5;
          // console.log(chars, cmds);
          if (chars.slice(0, 4).join("") === "span") {
            let spanClose = chars.findIndex(spanChar => {
              return spanChar === ">";
            });
            if (spanClose > -1) {
              let spanInfo = extractStyleAttributes("<" + chars.splice(0, spanClose + 1).join(""));
              if (spanInfo.color) {
                const broadcastColor = toBroadcastColor(spanInfo.color);
                textCmds.push(this.getCodeByCmd(sccLookup[channel], `{COLOR:${broadcastColor.toUpperCase()}}`));
              }
            }
          } else if (chars.slice(0, 6).join("") === "/span>") {
            chars.splice(0, 6);
            textCmds.push(this.getCodeByCmd(sccLookup[channel], "{COLOR:WHITE}"));
          } else if (this.isUnderlineItalicOpenTag(chars)) {
            chars.splice(0, 6);
            textCmds.push(this.getCodeByCmd(sccLookup[channel], "{ITALICS_UNDERLINE}"));
          } else if (this.isStrongOpenTag(chars)) {
            chars.splice(0, 7);
            textCmds.push(this.getCodeByCmd(sccLookup[channel], "{ITALICS}"));
          } else if (this.isItalicsOpenTag(chars)) {
            /* Remove Whitespace Before Format Tag */
            //console.log(textCmds);
            if (textCmds.length > 0 && textCmds[textCmds.length - 1] === this.getCodeByCmd(sccLookup[channel], " ")) {
              textCmds.pop();
              textCmds.push(this.getCodeByCmd(sccLookup[channel], "{ITALICS}"));
            } else if (textCmds.length > 0 && this.getCodeByCmd(sccLookup[channel], sccLookup[channel][textCmds[textCmds.length - 1]] + "{ITALICS}") != "80") {
              textCmds.push(this.getCodeByCmd(sccLookup[channel], sccLookup[channel][textCmds.pop()] + "{ITALICS}"));
            } else {
              textCmds.push(this.getCodeByCmd(sccLookup[channel], "{ITALICS}"));
            }
            chars.splice(0, 3);
          } else if (this.isUnderlineOpenTag(chars)) {
            /* Remove Whitespace Before Format Tag */
            if (textCmds.length > 0 && textCmds[textCmds.length - 1] === this.getCodeByCmd(sccLookup[channel], " ")) {
              textCmds.pop();
            }
            chars.splice(0, 2);
            textCmds.push(this.getCodeByCmd(sccLookup[channel], "{COLOR:WHITE;UNDERLINE}"));
          } else if (this.isUnderlineItalicCloseTag(chars)) {
            chars.splice(0, 8);
            textCmds.push(this.getCodeByCmd(sccLookup[channel], "{COLOR:WHITE}"));
          } else if (this.isStrongCloseTag(chars)) {
            chars.splice(0, 8);
            textCmds.push(this.getCodeByCmd(sccLookup[channel], "{COLOR:WHITE}"));
          } else if (this.isItalicsCloseTag(chars)) {
            if (chars.length > 4) {
              textCmds.push(this.getCodeByCmd(sccLookup[channel], "{COLOR:WHITE}"));
            }
            chars.splice(0, 4);
          } else if (this.isUnderlineCloseTag(chars)) {
            chars.splice(0, 3);
            textCmds.push(this.getCodeByCmd(sccLookup[channel], "{COLOR:WHITE}"));
          } else {
            horzOffset = horzOffset - 0.5;
            textCmds.push(this.getCodeByCmd(sccLookup[channel], char));
          }
        } else {
          textCmds.push(this.getCodeByCmd(sccLookup[channel], char));
        }
      }
      horzOffset = Math.round(horzOffset);
      /* Remove Position Commands to bottom so we can figure out if we need to offset captions */
      posCmds = this.getPositionCodes(line, details, index, channel, win, horzOffset);
      // console.log(line, posCmds, win);
      posCmds.forEach(cmd => {
        cmds.push(cmd);
      });

      /* "80" is the getCodeByCmd fallback for characters with no 608 mapping. Emitting it
         here would insert a pad byte in the middle of the text. */
      textCmds.filter(cmd => cmd && cmd !== "80").forEach(cmd => {
        cmds.push(cmd);
      });
    });

    // Optimize by combining position commands with italics commands when a short form exists
    let optimizedCmds = [];
    for (let i = 0; i < cmds.length; i++) {
      let currentCmd = cmds[i];
      let nextCmd = cmds[i + 1];

      // Check if there's a next command
      if (nextCmd) {
        // Look up what the current and next commands represent
        let currentCmdMeaning = sccLookup[channel][currentCmd];
        let nextCmdMeaning = sccLookup[channel][nextCmd];

        // Check if next command is an italics command
        if (nextCmdMeaning === "{ITALICS}") {
          // Try to find a combined command for position + italics
          let combinedCmd = this.getCodeByCmd(sccLookup[channel], currentCmdMeaning + "{ITALICS}");

          // If a combined command exists (and it's not the default "80"), use it
          if (combinedCmd && combinedCmd !== "80") {
            optimizedCmds.push(currentCmd);
            optimizedCmds.push(combinedCmd);
            i++; // Skip the next command since we combined it
            continue;
          }
        }
      }

      // No optimization possible, add command as-is
      optimizedCmds.push(currentCmd);
    }

    // console.log(details.plainText, optimizedCmds);

    return optimizedCmds;
  },
  formatEncodedCmds: function (encodedCmds) {
    let cmdString = "";
    for (let i = 0; i < encodedCmds.length; i++) {
      if (encodedCmds[i].length === 4) {
        cmdString += " " + encodedCmds[i];
      } else if (encodedCmds[i + 1] && encodedCmds[i].length === 2 && encodedCmds[i + 1].length === 2) {
        cmdString += " " + encodedCmds[i] + encodedCmds[++i];
      } else if (encodedCmds[i].length === 2 && (!encodedCmds[i + 1] || encodedCmds[i + 1].length === 4)) {
        cmdString += " " + encodedCmds[i] + "80";
      }
    }
    return cmdString.trim();
  },
  calculateEncodeTime: function (encodedTextString) {
    let encodeTime = 0;
    encodedTextString.split(" ").forEach(code => {
      if (sccLookup.all[code]) {
        encodeTime += 0.75;
      } else {
        encodeTime += 1;
      }
    });
    return Math.round(encodeTime);
  },
  verifyFormatting: function (event, win) {
    let result = true;
    //console.log("------");

    let plainText = convertToPlainText(event.text);
    // console.log(plainText);

    eol.split(plainText).forEach(textLine => {
      //console.log(textLine, textLine.length, event.xOffset, xOffset,textLine.length + xOffset + 4);     
      if (textLine.length > 32) {
        // console.log(textLine);
        result = false;
      }
    });
    return result;
  },
  replaceMusicNotes: function (line) {
    let matches = line.match(/♪+/g);
    if (!matches) {
      return line;
    }
    ;
    matches.forEach(noteMatch => {
      let regexPat = new RegExp(noteMatch);
      let musicNotes = Math.ceil(noteMatch.length / 2);
      line = line.replace(regexPat, "♪".repeat(musicNotes));
    });
    return line;
  },
  duplicateMusicNotes: function (line) {
    //Duplicate the number of musical notes by 2. Subtract 1 if the number of musical notes is > 1. For example, if there are two musical notes we would need to add 3 (instead of 4). But if there is 1 musical note we would need to add 2. 
    let matches = line.match(/♪+/g);
    if (!matches) {
      return line;
    }
    ;
    // console.log("----------")
    // console.log("Before: " + line);      

    line = line.replace(/♪/g, "♪♪");
    // console.log("After: " + line);
    return line;
  },
  isStrongOpenTag: function (chars) {
    return chars.slice(0, 7).join("") === "strong>";
  },
  isItalicsOpenTag: function (chars) {
    return chars.slice(0, 3).join("") === "em>";
  },
  isUnderlineOpenTag: function (chars) {
    return chars.slice(0, 2).join("") === "u>";
  },
  isUnderlineItalicOpenTag: function (chars) {
    return chars.slice(0, 6).join("") === "em><u>" || chars.slice(0, 6).join("") === "u><em>";
  },
  isStrongCloseTag: function (chars) {
    return chars.slice(0, 8).join("") === "/strong>";
  },
  isItalicsCloseTag: function (chars) {
    return chars.slice(0, 4).join("") === "/em>";
  },
  isUnderlineCloseTag: function (chars) {
    return chars.slice(0, 3).join("") === "/u>";
  },
  isUnderlineItalicCloseTag: function (chars) {
    return chars.slice(0, 8).join("") === "/em></u>" || chars.slice(0, 8).join("") === "/u></em>";
  },
  /* XDS Functions */
  encodeProgramName: function (programName) {
    if (programName && programName.length > 0) {
      //only accept the first 32 characters of program name
      let programNameArray = ["01", "83"];
      let name = programName ? programName.substring(0, 32) : "Unknown";
      let chars = name.split("");
      if (chars.length % 2 !== 0) {
        chars.push(" ");
      }
      ;
      chars.forEach(char => {
        programNameArray.push(this.getCodeByCmd(sccLookup["ch01"], char));
      });
      programNameArray.push("8f");
      programNameArray.push(this.calculateChecksum(programNameArray));
      //console.log(programName, programNameArray);
      return programNameArray;
    } else {
      return [];
    }
  },
  encodeProgramLength: function (hours, minutes) {
    if (!isNaN(hours) && !isNaN(minutes)) {
      let programHoursHex = hours ? parseInt(hours).toString(16).padStart(2, '0') : "00";
      let programMinutesHex = minutes ? parseInt(minutes).toString(16).padStart(2, '0') : "00";

      //Add 0x40 to the hex value of the hours and minutes
      let programHours = (parseInt("0x" + programHoursHex) + 0x40).toString(16);
      let programMinutes = (parseInt("0x" + programMinutesHex) + 0x40).toString(16);
      let programLengthArray = ["01", "02", programMinutes, programHours, "4040", "4040", "8f"];
      programLengthArray.push(this.calculateChecksum(programLengthArray));
      return programLengthArray;
    } else {
      return [];
    }
  },
  /* ratingType is the  MPAA, CAD FR, CAD EN, or TVPG*/
  /* RATING IS THE ACTUAL RATING */
  /* CONTENT DESCRIPTIONS IS AN ARRAY e.g. ["violence", "sex", "language", "dialogue"]*/
  encodeVChipInfo: function (ratingType, rating, contentDescriptions) {
    if (ratingType && rating) {
      // console.log(ratingType, rating, contentDescriptions)
      let vChipInfo = ["01", "85"];
      let vChipCode = [];
      if (ratingType === "TV Parental Guideline") {
        let d = contentDescriptions.includes("dialogue") ? "1" : "0";
        let v = contentDescriptions.includes("violence") ? "1" : "0";
        let s = contentDescriptions.includes("sex") ? "1" : "0";
        let l = contentDescriptions.includes("language") ? "1" : "0";
        let ratingCode = vchipLookup.ratingsBinaryMap[rating] || "000";
        let byte1 = "01" + d + "01000";
        let byte2 = "01" + v + s + l + ratingCode;

        // console.log(byte1, byte2);
        //convert byte 1 and byte 2 to hex
        byte1 = parseInt(byte1, 2).toString(16).padStart(2, '0');
        byte2 = parseInt(byte2, 2).toString(16).padStart(2, '0');
        vChipCode = [byte1, byte2];
        // console.log(vChipCode);
      } else {
        vChipCode = vchipLookup.ratingsMap[ratingType][rating];
      }
      vChipInfo = [...vChipInfo, ...vChipCode, "8f"];
      vChipInfo.push(this.calculateChecksum(vChipInfo));
      //console.log(vChipInfo);
      return vChipInfo;
    } else {
      return [];
    }
  },
  encodeProgramType: function (keywords) {
    if (keywords.length > 0) {
      let programTypeArray = ["01", "04"];
      keywords.forEach(keyword => {
        let programCode = sccLookup.xds.keywordGroupMap[keyword] || "26";
        programTypeArray.push(programCode);
      });
      programTypeArray.push("8f");
      programTypeArray.push(this.calculateChecksum(programTypeArray));
      return programTypeArray;
    } else {
      return [];
    }
  },
  encodeAfdInfo: function (afd) {
    return ["0189"];
  },
  calculateChecksum: function (hexArray) {
    // Convert hexadecimal strings to decimal numbers and sum them up
    const sum = hexArray.reduce((acc, hex) => acc + parseInt(hex, 16), 0);
    // Calculate the adjustment needed for divisibility by 0x80
    const adjustment = 0x80 - sum % 0x80;
    // Calculate the checksum value
    const checksum = adjustment & 0xFF; // Ensure checksum is in the range 0-255

    //Return 2-digit checksum hex value 
    return checksum.toString(16).toUpperCase().padStart(2, "0"); // Convert checksum to hexadecimal string
  },
  // loop over all of the events in each event group and add up the number of events where processed = false;
  getNumberOfEventsToProcess: function (eventGroupChannelMappings) {
    let eventsToProcess = 0;
    Object.keys(eventGroupChannelMappings).forEach(ch => {
      if (!eventGroupChannelMappings[ch]) {
        return;
      }
      eventGroupChannelMappings[ch].events.forEach(event => {
        if (!event.processed) {
          eventsToProcess++;
        }
      });
    });
    return eventsToProcess;
  },
  getEventsToProcess: function (eventGroupChannelMappings, frameCount) {
    let eventsToProcess = [];
    Object.keys(eventGroupChannelMappings).forEach(ch => {
      if (!eventGroupChannelMappings[ch]) {
        return;
      }

      //Find the next event to process (processed === false), and check that the event.encodeStartTime is => frameCount.
      eventGroupChannelMappings[ch].events.find(event => {
        if (!event.processed && event.encodeStartTime <= frameCount) {
          eventsToProcess.push(event);
          return true;
        }
      });
    });
    return eventsToProcess;
  },
  //Loop over the ccChannelStatus array which stores objects for each channel (1-4). Each object has a screen and buffer property that will store the event currently on screen and currently in the buffer. If there is a screen event, check if the event endFrame property === frameCount (if it does match then we need to clear it off the screen). We also need to check if the buffer needs to be displayed. 
  getDisplayOrClearCommands: function (ccChannelStatus, frameCount) {
    let displayCommands = {
      "dtv": {
        "programA": [],
        "programB": [],
        "programC": [],
        "programD": [],
        "programE": [],
        "programF": []
      },
      "atv": {
        "ch01": [],
        "ch02": [],
        "ch03": [],
        "ch04": []
      },
      "scc": []
    };
    // console.log(ccChannelStatus);
    ccChannelStatus.forEach((channel, index, channels) => {
      // console.log(channel.id, (channel.buffer ? channel.buffer.startFrame : ''), frameCount);
      if (channel.buffer && channel.buffer.startFrame <= frameCount) {
        //console.log("DISPLAYING BUFFER for channel", channel.id, frameCount);
        if (channel.id.includes("ch0")) {
          displayCommands.scc.push(this.getCodeByCmd(sccLookup[channel.id], "{DISPLAY BUFFER}"));
          displayCommands.scc.push(this.getCodeByCmd(sccLookup[channel.id], "{CLEAR BUFFER}"));
          displayCommands.atv[channel.id].push(this.getCodeByCmd(sccLookup[channel.id], "{DISPLAY BUFFER}"));
          displayCommands.atv[channel.id].push(this.getCodeByCmd(sccLookup[channel.id], "{CLEAR BUFFER}"));
        } else {
          const windowBit = w => (1 << (Number(w) || 0)).toString(16).padStart(2, "0").toUpperCase();
          if (channel.screen) {
            const oldBit = windowBit(channels[index].screen.dtvWindow);
            const newBit = windowBit(channel.buffer.dtvWindow);
            //console.log(`Clearing screen for ${channels[index].screen.dtvWindow}`);
            /* Hide old window */
            displayCommands.dtv[channel.id].push("8A");
            displayCommands.dtv[channel.id].push(oldBit);
            /* Clear the old Window */
            displayCommands.dtv[channel.id].push("88");
            displayCommands.dtv[channel.id].push(oldBit);

            //console.log(`Toggle new window`);
            /* Toggle new window */
            displayCommands.dtv[channel.id].push("8B");
            displayCommands.dtv[channel.id].push(newBit);

            //console.log(`Deleting window for ${channels[index].screen.dtvWindow}`);
            /* Delete the old Window */
            displayCommands.dtv[channel.id].push("8C");
            displayCommands.dtv[channel.id].push(oldBit);
          } else {
            // console.log(`Toggling window: ${channel.buffer.dtv}`);
            displayCommands.dtv[channel.id].push("8B");
            displayCommands.dtv[channel.id].push(windowBit(channel.buffer.dtvWindow));
          }
        }
        channels[index].screen = channel.buffer;
        channels[index].buffer = null;
      } else if (channel.screen && channel.screen.endFrame <= frameCount && !channel.screen.style.startsWith("Roll-Up")) {
        // console.log("CLEARING SCREEN for channel", channel.id, frameCount, channel.screen);
        if (channel.id.includes("ch0")) {
          displayCommands.scc.push(this.getCodeByCmd(sccLookup[channel.id], "{CLEAR DISPLAY}"));
          displayCommands.atv[channel.id].push(this.getCodeByCmd(sccLookup[channel.id], "{CLEAR DISPLAY}"));
        } else {
          const windowBit = w => (1 << (Number(w) || 0)).toString(16).padStart(2, "0").toUpperCase();
          const bit = windowBit(channels[index].screen.dtvWindow);
          //console.log(`Clearing screen for ${channels[index].screen.dtvWindow}`)
          /* Hide Windows */
          displayCommands.dtv[channel.id].push("8A");
          displayCommands.dtv[channel.id].push(bit);
          /* Clear the Window */
          displayCommands.dtv[channel.id].push("88");
          displayCommands.dtv[channel.id].push(bit);
          /* Delete the Window */
          //console.log("Deleting Window");
          displayCommands.dtv[channel.id].push("8C");
          displayCommands.dtv[channel.id].push(bit);
        }
        channels[index].screen = false;
        //console.log(displayCommands);
      }
    });
    return displayCommands;
  },
  //Check the ccChannelStatus to see if there are events stored in the buffer or screen that need to be shown, or cleared. To do this, loop over the ccChannelStatus array to check if there is a screen or buffer event. If there is a screen event, check to see if the event endFrame property <= frameCount. If it is, return true. We also need to check the buffer event to see if the startFrame property >= frameCount. If it is, return true (meaning we haven't shown it yet).
  eventsToDisplay: function (ccChannelStatus, frameCount) {
    // console.log("-----------");
    // console.log(ccChannelStatus);
    let displayOrClear = false;
    ccChannelStatus.forEach(channel => {
      if (channel.screen && channel.screen.endFrame >= frameCount) {
        displayOrClear = true;
      }
      if (channel.buffer && (!channel.screen || channel.buffer.startFrame >= frameCount)) {
        displayOrClear = true;
      }
    });
    return displayOrClear;
  },
  replaceSpecialChars: function (text) {
    sccLookup.specialCharsFilter.forEach(specialChar => {
      //We need to first replace duplicate special characters with their replacement character. This avoids complications when doing the final replacement. For example, if the specialChar = "¿", and the text contains "¿¿", we need to first convert it to "?¿" before removing the character before the special character.
      let regexPatternDup = new RegExp(`\\` + specialChar + `\\` + specialChar, "g");
      text = text.replace(regexPatternDup, sccLookup.specialCharacterReplacement[specialChar] + specialChar);

      /* Remove the character before special character if the character before is not a > */
      let regexPattern = new RegExp(`([^>]){1}\\` + specialChar, "g");
      text = text.replace(regexPattern, specialChar);
    });
    text = text.replace("!¡", "¡");
    text = text.replace("?¿", "¿");
    return text;
  }
};